"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
class User {
    constructor(user) {
        this.id = 0;
        this.email = '';
        this.isLogged = false;
        this.authEnabled = false;
        this.registered = false;
        this.language = '';
        this.mobilePhone = '';
        this.role = '';
        this.blocked = false;
        if (!user) {
            return;
        }
        this.isLogged = user.isLogged;
        this.id = user.id;
        this.nickname = user.nickname;
        this.email = user.email;
        this.token = user.token;
        this.authEnabled = user.authEnabled;
        this.authSecret = user.authSecret;
        this.language = user.language;
        this.mobilePhone = user.mobilePhone;
        this.role = user.role;
        this.blocked = user.blocked;
    }
}
exports.User = User;
//# sourceMappingURL=user.js.map